<div [formGroup]="form">
  <div class="form-spacing">
    <div class="column">
      <label class="label">{{ 'pre-employment.selfservice.declaration-date.label' | translate }}</label>
      <p class="text-dark">{{ form.get('createdAt')?.value | date: 'dd/MM/yyyy' }}</p>
    </div>

    <div class="column">
      <p class="text-dark" [innerHTML]="'selfservice-request.tfr-declaration.notes.label' | translate"></p>
    </div>

    <div class="column">
      <div class="row gap-small mb-2">
        <p-radiobutton
          inputId="tfr-firstTime"
          name="tfrPrimaryChoice"
          formControlName="tfrPrimaryChoice"
          [value]="'firstTime'"
          (onChange)="selectOption('firstTime')"
        ></p-radiobutton>
        <label for="tfr-firstTime" class="label">
          {{ 'selfservice-request.tfr-declaration.firstTime.label' | translate }}
        </label>
      </div>
      @if (isFirstTimeSelected()) {
        <div class="column conditional-choice mb-2">
          <div class="row gap-small">
            <p-checkbox inputId="tfr-inCompany" formControlName="inCompany" [binary]="true"></p-checkbox>
            <label for="tfr-inCompany" class="label">
              {{ 'selfservice-request.tfr-declaration.inCompany.label' | translate }}
            </label>
          </div>
        </div>
      }

      <div class="row gap-small mb-2">
        <p-radiobutton
          inputId="tfr-alreadyInCompany"
          name="tfrPrimaryChoice"
          formControlName="tfrPrimaryChoice"
          [value]="'alreadyInCompany'"
          (onChange)="selectOption('alreadyInCompany')"
        ></p-radiobutton>
        <label for="tfr-alreadyInCompany" class="label">
          {{ 'selfservice-request.tfr-declaration.alreadyInCompany.label' | translate }}
        </label>
      </div>

      <div class="row gap-small mb-2">
        <p-radiobutton
          inputId="tfr-ransom"
          name="tfrPrimaryChoice"
          formControlName="tfrPrimaryChoice"
          [value]="'ransom'"
          (onChange)="selectOption('ransom')"
        ></p-radiobutton>
        <label for="tfr-ransom" class="label">
          {{ 'selfservice-request.tfr-declaration.ransom.label' | translate }}
        </label>
      </div>

      <div class="row gap-small">
        <p-radiobutton
          inputId="tfr-notRansom"
          name="tfrPrimaryChoice"
          formControlName="tfrPrimaryChoice"
          [value]="'notRansom'"
          (onChange)="selectOption('notRansom')"
        ></p-radiobutton>
        <label for="tfr-notRansom" class="label">
          {{ 'selfservice-request.tfr-declaration.notRansom.label' | translate }}
        </label>
      </div>

      @if (form.get('tfrPrimaryChoice')?.value === 'notRansom') {
        <div class="column mt-2">
          <p class="text-dark" [innerHTML]="'selfservice-request.tfr-declaration.notRansom.note' | translate"></p>
        </div>
      }

      <small
        class="text-red-500 p-error"
        *ngIf="form.errors?.['tfrDeclarationOptionRequired'] && (form.dirty || form.touched)"
      >
        {{ 'selfservice-request.tfr-declaration.validation.option-required' | translate }}
      </small>
    </div>
  </div>
</div>
